import React, { useEffect } from "react";
import "../Css/Story.css";
import underconstruction1 from '../Components/image/underconstruction1.png'
import Footer from '../Components/Footer';
import Aos from "aos";
import 'aos/dist/aos.css';
function Story() {
  useEffect(() => {
    document.title = "story";
  });
  useEffect(()=>
  {
    Aos.init({duration:2000})
  },[])
  return (
    <div>
    <div id="storymain"
    data-aos="zoom-in-out"
    >
      <img src={underconstruction1} alt="underconstrucition_image" />
    </div>
<div className="container-fluid">
<div className="row">
   {<Footer/>}
</div>
</div>
    </div>
  );
}
export default Story;
